import { Move } from 'lucide-react';

/** A small "Drag to move" pill in the middle of the crop box. */
export function CropDragHint() {
  return (
    <span
      style={{
        position: 'absolute',
        left: '50%',
        top: '50%',
        transform: 'translate(-50%, -50%)',
        display: 'inline-flex',
        alignItems: 'center',
        gap: 5,
        fontSize: 10.5,
        fontWeight: 700,
        padding: '4px 9px',
        borderRadius: 999,
        background: 'rgba(15,25,18,.55)',
        color: '#fff',
        pointerEvents: 'none',
        whiteSpace: 'nowrap',
      }}
    >
      <Move size={11} aria-hidden="true" />
      Drag to move
    </span>
  );
}
